import { render, staticRenderFns } from "./TireSizeView.vue?vue&type=template&id=0f5c11d4&"
import script from "./TireSizeView.vue?vue&type=script&lang=js&"
export * from "./TireSizeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports